import React from 'react';

const Shop = () => (
	<div class='mt-5'>
		<section className='container'>
			<h1>Welcome to our Shop</h1>
		</section>
	</div>
);

export default Shop;
